const base = 'https://marketing.chuanbaoguancha.cn/v1/community/';
const h5base = 'https://h5.chuanbaoguancha.cn'
const Api = {
  setting(id){
    return `${h5base}/cbgc-miniprogram/app/api.php?name=cbgc&id=${id}`
  },
  publish(typeid, include){
    // include: user
    return `${base}content?type_id=${typeid}${include ? '&include='+include : ''}`;
  },
  list(typeid, page, include, topic){
    // include: user, comment
    return `${base}contents?type_id=${typeid}${page?'&page='+page : ''}${topic ? '&topic='+topic : ''}${include ? '&include='+include : ''}`;
  },
  detail(id, include){
    // include: user, comment
    return `${base}content/${id}${include ? '?include='+include : ''}`;
  },
  zan(id){
    return `${base}content/${id}/like`;
  },
  comments(id, include){
    return `${base}content/${id}/comments${include?'?include='+include : ''}`;
  },
  comment(id){
    return `${base}content/${id}/comment`;
  },
  profile(id){
    return `${base}user/${id}`;
  },
  follow(id){
    return `${base}user/${id}/follow`;
  },
  deleteContent(contentId, id){
    return `${base}content/${contentId}?id=${id}`;
  },
  deleteComment(id){
    return `${base}comment/${id}`;
  },
  authorityUser(typeid){
    return `${base}user/authority?type_id=${typeid}`;
  },
  commentRank(typeid){
    return `${base}comment/score/rank?type_id=${typeid}`;
  },
  commentScore(id,score){
    return `${base}comment/score?comment_id=${id}&score=${score}`;
  }
}

export default Api;

